import { defineStore } from 'pinia'

const defaultSettings = {
    fontSize: 6,
    numberOfColumns: 0,
    participateLimit: 60,
    showAvailableSlots: false,
    showOptions: true,
    tableSize: 4,
    tableCountStart: 1,
    darkModeToggle: false
}

export const useSettingsStore = defineStore('SettingsStore', {
    state: () => ({ ...defaultSettings }),
    persist: true,
    actions: {
        reset() {
            for (const [key, value] of Object.entries(defaultSettings)) {
              this[key] = value
            }
        },
        toggleOptions() {
            this.showOptions = !this.showOptions
        }
    }
})
